import { useContext } from 'react';
import { Typography, Grid } from '@mui/material';
import { orderContext } from '../OrderContext';
import { DetailsPageHeader } from 'components';

let LengowComments = () => {
    let service = useContext(orderContext);

    return (
        <DetailsPageHeader sectionName='Lengow comments'>
            <Grid container>
                <Grid item xs={3}>
                    <Typography>Comments</Typography>
                </Grid>
                <Grid item xs={9}>
                    {(service.order.lengowComments && service.order.lengowComments.length !== 0) &&
                        <Typography>{service.order.lengowComments}</Typography>
                    }
                    {(!service.order.lengowComments || service.order.lengowComments.length === 0) &&
                        <Typography variant="subtitle2">No comments found</Typography>
                    }
                </Grid>
            </Grid>
        </DetailsPageHeader>
    );
}

export default LengowComments;